/* Keep the collection filter drawer open while applying filters.
   facets.js re-renders the section on each filter change; if anything drops
   the drawer's open state, re-assert it so the panel does not vanish.
   No-ops if the drawer simply stays open. Respects an explicit close. */
(function () {
  function init() {
    var drawer = document.querySelector('menu-drawer.facets__drawer');
    if (!drawer) return;
    var details = drawer.querySelector('details');
    var summary = drawer.querySelector('summary');
    var form = drawer.querySelector('form');
    if (!details || !form) return;

    var keepOpenUntil = 0;

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('input[type="checkbox"], input[type="radio"], input[name^="filter"]')) {
        if (details.hasAttribute('open')) keepOpenUntil = Date.now() + 3000;
      }
    }, true);

    // Let an explicit close (X / Apply / summary tap) actually close it.
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('.js-btn-close-drawer, summary')) keepOpenUntil = 0;
    }, true);

    new MutationObserver(function () {
      if (!details.hasAttribute('open') && Date.now() < keepOpenUntil) {
        details.setAttribute('open', '');
        details.classList.add('menu-opening');
        if (summary) summary.classList.add('menu-is-open');
        var h = document.getElementById('header');
        if (h) h.classList.add('menu-open');
      }
    }).observe(details, { attributes: true, attributeFilter: ['open'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
